
import { DriverService } from '@/service/driver/driver';
import { serviceVersion } from '@/service/env';
import { compare } from 'compare-versions';
import { ref } from 'vue';
export enum VersionStatus {
    NoUpdate = 0,
    Upgrading = 1,
    Error = 2,
    Success = 3
}
class DriverServiceVersion {

    // service最低更新版本要求，支持service退出功能的版本
    private minServiceVersionForExit: string = "2.1.3";

    //script 对应service版本，用于强制更新service版本，要注意版本号
    private scriptVersionToServiceVersion = serviceVersion();

    public isShowServiceUpdate = ref(false)

    public serviceUpdateVersionStatus = VersionStatus.NoUpdate
    // ~- script升级后, 要判断service的版本是否匹配, 不匹配的话, 提示升级service
    // 对比版本，提示是否升级
    public async checkServiceVersion() {
        const useVersion = await DriverService.instance.exeDriver.getServiceVersion();
        if (compare(useVersion, this.minServiceVersionForExit, '<')) {
            return
        }
        console.log(`currentServiceVersion:${useVersion},scriptVersionToServiceVersion:${this.scriptVersionToServiceVersion}`);
        if (compare(useVersion, this.scriptVersionToServiceVersion, '>=')) { // TODO: 不提示更新，退出在进会自动更新
            return
        }
        this.isShowServiceUpdate.value = true;
    }
}

const driverServiceVersion = new DriverServiceVersion();
export { driverServiceVersion };
